<template>
  <div id="letter-from-our-board-chair" class="section-content">
    <div class="grid-container">
      <div class="grid-x grid-margin-x align-center">
        <div class="cell small-10 large-8 board-chair">
          <div class="board-chair__letter"
               data-aos="fade-right"
               data-aos-delay="200"
               data-aos-duration="600"
               data-aos-offset="100">
            <div class="board-chair__hr rel">
              <PillsAccent
                :top="-44"
                :right="-62"
              >
                <PillColumn>
                  <Pill
                    color="gold"
                    height="medium"
                  />
                </PillColumn>
                <PillColumn>
                  <Pill
                    color="purple"
                    height="medium"
                    :offset="2"
                  />
                </PillColumn>
              </PillsAccent>
            </div>
            <h2 class="text-purple">A Letter from our Board Chair</h2>
            <h3 class="text-purple">Hugh Francis, III, MD</h3>
            <div class="flex-container">
              <div class="letter-photo">
                <div class="pill-mask">
                  <div
                    class="pill-photo"
                    :style="{ backgroundImage:'url(' + require('@/assets/hugh-francis-2022.jpg') + ')' }"
                  ></div>
                </div>
                <PillsAccent
                  :top="-16"
                  :left="-16"
                >
                  <PillColumn>
                    <Pill
                      color="gold"
                      height="short"
                    />
                    <Pill
                      color="purple"
                      height="medium"
                      :offset="1"
                    />
                  </PillColumn>
                </PillsAccent>
              </div>
              <p>
                SVMIC exists to serve physicians. This company was founded in 1975 when commercial carriers stopped offering the medical professional liability insurance doctors needed. At that time a group of visionary physicians collaborated to create this mutually-owned insurance company and thus take control of a very important aspect of doctors’ professional and personal lives. At first, the company’s only purpose was to provide a reliable source of medical malpractice insurance, but now SVMIC has expanded to help doctors be successful through a broad range of support and advocacy services.
              </p>
            </div>
            <p>
              Today, SVMIC continues to be proudly owned and governed by doctors. Fourteen of SVMIC’s sixteen directors are physicians. These directors oversee SVMIC’s operations, provide governance to the management team, and help establish the company’s strategy. This board leads with a remarkable commitment to the company’s policyholders.
            </p>
            <p>
              Doctors’ leadership at SVMIC goes well beyond its board of directors. SVMIC’s governance committees are composed almost entirely of physicians, and these committees oversee claims management, underwriting, and financial operations.  Doctors on the risk management committee help select and develop risk education programs. This physician guidance ensures that SVMIC’s products and services are in line with the wants and needs of its physician members.
            </p>
            <div class="accents-pad">
              <p>
                Perhaps most importantly, physician leadership ensures that SVMIC remains committed both to the high levels of service that its policyholders expect and to the strong legal defense that its policyholders deserve. SVMIC has never wavered from its promise to vigorously defend good medicine and good doctors. This commitment is a fundamental part of SVMIC’s culture and is evident in the dedication of its team members at every level.
              </p>
              <p>
                Helping doctors be successful will always be SVMIC’s focus. Everyone at this company shares this commitment and is honored to serve its physicians. Thank you for placing your trust in SVMIC.
              </p>
              <PillsAccent
                :top="-30"
                :right="-150"
              >
                <PillColumn>
                  <Pill
                    color="mediumBlue"
                    height="tall"
                    :offset="4"
                  />
                </PillColumn>
                <PillColumn>
                  <Pill
                    color="indigo"
                    height="short"
                  />
                  <Pill
                    color="mediumBlue"
                    height="xxxtall"
                    :offset="1"
                  />
                  <Pill
                    color="tangerine"
                    height="xxtall"
                    :offset="2"
                  />
                  <Pill
                    color="indigo"
                    height="tall"
                  />
                </PillColumn>
                <PillColumn>
                  <Pill
                    color="tangerine"
                    height="tall"
                    :offset="3"
                  />
                  <Pill
                    color="paleBlue"
                    height="tall"
                    :offset="2"
                  />
                </PillColumn>
              </PillsAccent>
            </div>
            <p>Sincerely,</p>
            <div class="board-chair__signature">
              <div class="board-chair__signature__subtext"
                 data-aos="fade-in"
                 data-aos-delay="400"
                 data-aos-duration="1000"
                 data-aos-offset="100">
              <h3 class="text-purple">Hugh Francis, III, MD</h3>
              <p>Chair, SVMIC Board of Directors</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pill from '@/components/pills/Pill';
import PillColumn from '@/components/pills/PillColumn';
import PillsAccent from '@/components/pills/PillsAccent';

export default {
  name: 'HomeLetter',
  components: {
    Pill,
    PillColumn,
    PillsAccent
  }
};
</script>
